<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch1-2">
<p class="centerImage"><img alt="images" id="img7" src="images/img7.jpg" style="max-width:100%;"/></p>
<p class="caption"><span class="t22">Frontispiece from</span> <span class="t3"><em class="italic">A Treatise on Duelling,</em></span> <span class="t3">1818.</span> <span class="smallcaps">Author’s collection</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_ch12.vue?3d439925